import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/api";
import toast from "react-hot-toast";
import ProjectForm from "./ProjectForm";

const AdminAddProject = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const createProject = async (payload) => {
    try {
      setLoading(true);
      await api.post("/projects", payload);
      toast.success("Project created successfully");
      navigate("/admin/projects");
    } catch (err) {
      toast.error(err.cleanMessage || "Failed to create project");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-black text-[#0b6b1d]">
          Add Project
        </h1>
        <p className="text-slate-500 mt-1">
          Create a new infrastructure project.
        </p>
      </div>

      <ProjectForm onSubmit={createProject} loading={loading} />
    </div>
  );
};

export default AdminAddProject;